/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import Banner from '../components/Banner';
import Features from '../components/Features';
import PlatformSection from '../components/home/PlatformSection';
import UseCasesSection from '../components/home/UseCasesSection';
import StackSection from '../components/home/StackSection';
import RoadmapSection from '../components/home/RoadmapSection';
import ReadyToTransformSection from '../components/home/ReadyToTransformSection';
import Footer from '../components/Footer';
import Header from '../components/Header';
import '../styles/Home.css'


function Home() {
  return (
    <>
      <Header />
      <Banner />
      <PlatformSection />
      <Features />
      <UseCasesSection />
      <StackSection />
      <RoadmapSection />
      <ReadyToTransformSection />
      <Footer />
    </>
  );
}

export default Home;
